export default "__VITE_ASSET__Bgd2qtRP__"